import React from 'react';
import { theme, darkColors, lightColors } from '@tryhackme/thm-ui-components';
import { ThemeProvider } from 'styled-components';
import { ThemeColorMode } from 'src/common/enums';
const colors = {
  dark: darkColors,
  light: lightColors
};
const ForceTheme = ({
  themeMode,
  children
}: {
  themeMode: ThemeColorMode;
  children: React.ReactNode;
}) => <ThemeProvider theme={{
  ...theme,
  colors: colors[themeMode]
}} data-sentry-element="ThemeProvider" data-sentry-component="ForceTheme" data-sentry-source-file="index.tsx">{children}</ThemeProvider>;
export { ForceTheme };